import { AlertModal, LiliButtonType } from '@lili/lili-frontend-common';
import { useTranslation } from 'react-i18next';
import { OnboardingFormFields } from '@Types/index';
import { OtherForm } from './OtherForm/OtherForm';
import { useOtherFormLogic } from './OtherForm/hooks/useOtherFormLogic';

interface OtherAccountOpeningReasonModalProps {
  onSubmit: (reason: string) => void;
  onCancel: () => void;
  isLoading?: boolean;
}
export const OtherAccountOpeningReasonModal = ({
  onSubmit,
  onCancel,
  isLoading,
}: OtherAccountOpeningReasonModalProps) => {
  const { t } = useTranslation();

  const {
    formMethods,
    formMethods: { watch, formState },
  } = useOtherFormLogic();
  const { errors } = formState;

  const reason = watch(OnboardingFormFields.ACCOUNT_OPENING_REASON);
  const handleSubmit = () => {
    onSubmit(reason);
  };
  return (
    <AlertModal
      title={t('pages.accountOpeningReason.otherModal.title')}
      submitButtonType={LiliButtonType.PRIMARY}
      submitButtonTitle={t('pages.accountOpeningReason.otherModal.cta')}
      cancelButtonTitle={t('pages.accountOpeningReason.otherModal.cancel')}
      onSubmit={handleSubmit}
      onCancel={onCancel}
      isDisabled={!errors}
      isLoading={isLoading}
      isSmallTitle>
      <div className='mt-[28px]'>
        <OtherForm formMethods={formMethods} />
      </div>
    </AlertModal>
  );
};
